(function () {
  var moneyFmt = function (cents) { return '$' + (cents / 100).toFixed(2); };

  function root() { return document.querySelector('[data-mt-cart-extras]'); }

  async function getCart() {
    try { var r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); return await r.json(); }
    catch (e) { return null; }
  }

  function render(cart) {
    var el = root();
    if (!el || !cart) return;
    var tAttr = el.getAttribute('data-mt-threshold');
    var threshold = tAttr === null || tAttr === '' ? 5000 : parseInt(tAttr, 10);
    if (isNaN(threshold)) threshold = 5000;
    var bundleId = el.getAttribute('data-mt-bundle-variant');
    var coreIds = [el.getAttribute('data-mt-vacuum'), el.getAttribute('data-mt-gap'), el.getAttribute('data-mt-trash')];

    // Free-shipping progress bar
    var bar = el.querySelector('[data-mt-ship-bar]');
    var text = el.querySelector('[data-mt-ship-text]');
    var fill = el.querySelector('[data-mt-ship-fill]');
    if (cart.item_count > 0) {
      bar.hidden = false;
      var total = cart.total_price;
      if (threshold <= 0 || total >= threshold) {
        text.innerHTML = '✅ <strong>Free shipping</strong> included on your order';
        fill.style.width = '100%';
      } else {
        var falta = threshold - total;
        text.innerHTML = 'Add <strong>' + moneyFmt(falta) + '</strong> more for free shipping';
        fill.style.width = Math.min(100, (total / threshold) * 100) + '%';
      }
    } else {
      bar.hidden = true;
    }

    // Bundle upsell: show if a core product is in cart but the bundle is not
    var upsell = el.querySelector('[data-mt-upsell]');
    var productIds = cart.items.map(function (i) { return String(i.product_id); });
    var variantIds = cart.items.map(function (i) { return String(i.variant_id || i.id); });
    var hasCore = coreIds.some(function (id) { return productIds.indexOf(String(id)) !== -1; });
    var hasBundle = variantIds.indexOf(String(bundleId)) !== -1 ||
      cart.items.some(function (i) { return String(i.product_id) === '9335794401496'; });
    upsell.hidden = !(hasCore && !hasBundle);
  }

  async function refresh() { render(await getCart()); }

  async function refreshDawnDrawer() {
    // Re-render Dawn's cart drawer via the Section Rendering API
    try {
      var res = await fetch(window.location.pathname + '?section_id=cart-drawer');
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      var current = document.querySelector('#CartDrawer');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('active') === false) drawer.classList.add('active');
    } catch (e) {}
    refresh();
  }

  async function addBundle(btn) {
    var el = root();
    if (!el) return;
    var bundleId = el.getAttribute('data-mt-bundle-variant');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(bundleId, 10), quantity: 1 }] })
      });
      await refreshDawnDrawer();
    } catch (e) {
      btn.disabled = false;
      btn.textContent = 'Add Bundle · $79.95';
    }
  }

  function bind() {
    var el = root();
    if (!el) return;
    var addBtn = el.querySelector('[data-mt-upsell-add]');
    if (addBtn && !addBtn.dataset.mtBound) {
      addBtn.dataset.mtBound = '1';
      addBtn.addEventListener('click', function () { addBundle(addBtn); });
    }
  }

  // Expuesto para que el add-to-cart AJAX (mt-scripts.js) lo llame tras
  // reemplazar el contenido del carrito lateral.
  window.mtCartRefresh = function () { bind(); refresh(); };

  function init() {
    if (window.__mtCartBooted) return;
    window.__mtCartBooted = true;
    // Observa el contenedor PERSISTENTE del drawer (su interior se reemplaza
    // al añadir/quitar; observar un hijo que se sustituye rompía el refresco).
    var host = document.querySelector('#CartDrawer') || document.querySelector('cart-drawer');
    if (host && 'MutationObserver' in window) {
      new MutationObserver(function () { bind(); refresh(); }).observe(host, { childList: true, subtree: true });
    }
    bind();
    refresh();
    document.addEventListener('click', function (e) {
      if (e.target.closest('#cart-icon-bubble, [href$="/cart"], .cart-drawer, cart-drawer')) {
        setTimeout(refresh, 250);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
